/*
 * ****************************************************************
 * File: keyboard.js
 * Project: CPaaS
 * Owner: Radisys
 *
 * Copyright - 2021 Radisys Corporation.
 * All rights reserved. No part of this software may be used or
 * reproduced in any form by any means without the prior written
 * permission of Radisys Corporation.
 *
 * Author: Pavan Kumar
 *
 * ****************************************************************
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Button, Grid, Popover, TextField } from '@material-ui/core';
import { Backspace } from '@material-ui/icons';
import VideoIcon from '../assets/Video_Icon.svg';
import AudioIcon from '../assets/Audio_Icon.svg';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  buttonrow: {
    flexDirection: 'row',
    minWidth: '30%',
    margin: 'auto',
    marginTop: '3vh',
  },
  buttoncenter: {
    justifyContent: 'center',
    flexDirection: 'row',
    display: 'flex',
  },
}));

const Keyboard = ({
  open,
  anchorEl,
  setRemoteURI,
  remoteURI,
  inputRef,
  makeCall,
  setCallDate,
}) => {
  const classes = useStyles();
  const calcBtns = [
    "1",
    "2",
    "3",
    "A",
    "4",
    "5",
    "6",
    "B",
    "7",
    "8",
    "9",
    "C",
    "*",
    "0",
    "#",
    "D",
  ];

  React.useEffect(() => {
    if (inputRef.current && inputRef.current.value !== remoteURI) {
      inputRef.current.value = remoteURI;
    }
  }, [remoteURI]);

  function manipulate(operation, key) {
    const input = inputRef.current;
    let cursorLocation = input.selectionStart;
    const currentString = inputRef.current.value;
    if (operation === "add") {
      const data =
        currentString.slice(0, cursorLocation) +
        key +
        currentString.slice(cursorLocation);
      input.value = data;
      input.focus();
      input.setSelectionRange(cursorLocation + 1, cursorLocation + 1);
    } else {
      if (cursorLocation === 0) {
        return;
      }
      const data =
        currentString.slice(0, cursorLocation - 1) +
        currentString.slice(cursorLocation, currentString.length);
      input.value = data;
      input.focus();
      input.setSelectionRange(cursorLocation - 1, cursorLocation - 1);
    }
    //setRemoteURI(input.value);/// DO not do this here
  }

  return (
    <div
      style={{
        background: "transparent",
        margin: "auto",
        justifyContent: "center",
        alignSelf: "center",
        marginTop: "3vh",
      }}
    >
      <Grid container item xs={12} justify="center" style={{ margin: "auto" }}>
        <Grid xs={12} md={7} lg={9} item>
          <Popover
            style={{ minWidth: "60%" }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "right",
              horizontal: "center",
            }}
          ></Popover>

          <Grid
            xs={12}
            md={7}
            lg={9}
            item
            wrap="nowrap"
            className={classes.buttonrow}
          >
            <TextField
              placeholder="Phone Number/SIP URI"
              style={{
                width: "90%",
                margin: "5px",
                marginTop: "5vh",
              }}
              autoFocus
              variant="outlined"
              size="small"
              margin="none"
              name="remoteURI"
              InputProps={{
                inputRef: inputRef,
              }}
            />
            <div>
              {calcBtns.map((item, i) => {
                return (
                  <Button
                    data-testid={"btn" + i}
                    key={item + i}
                    variant="outlined"
                    style={{
                      borderRadius: "0px",
                      margin: "0.1rem",
                      background: "#E6F7FF",
                      minWidth: "22%",
                      height: "45px",
                    }}
                    onClick={(e) => manipulate("add", e.target.textContent)}
                    // onClick={(e) => {
                    //   setRemoteURI(
                    //     inputRef.current.value + e.target.textContent
                    //   );
                    // }}
                    defaultValue={item}
                  >
                    {item}
                  </Button>
                );
              })}
              <Button
                data-testid="video"
                id="video"
                variant="outlined"
                style={{
                  borderRadius: "0px",
                  margin: "0.1rem",
                  background: "#314B9F",
                  minWidth: "33%",
                  height: "60px",
                }}
                onClick={() => {
                  setRemoteURI(inputRef.current.value);
                  setCallDate(Date.now());
                  makeCall({
                    audio: true,
                    video: true,
                    remoteURI: inputRef.current.value,
                  });
                }}
              >
                <img
                  src={VideoIcon}
                  style={{ marginLeft: "-10px", width: "20px", height: "20px" }}
                />
                <p
                  style={{
                    color: "#FFFF",
                    fontSize: "12px",
                    marginLeft: "10px",
                  }}
                >
                  Video
                </p>
              </Button>
              <Button
                data-testid="audio"
                id="audio"
                variant="outlined"
                style={{
                  borderRadius: "0px",
                  margin: "0.1rem",
                  background: "#314B9F",
                  minWidth: "33.2%",
                  height: "60px",
                  justifyContent: "center",
                }}
                onClick={() => {
                  setRemoteURI(inputRef.current.value);
                  setCallDate(Date.now());
                  makeCall({
                    audio: true,
                    video: false,
                    remoteURI: inputRef.current.value,
                  });
                }}
              >
                <img
                  style={{ marginLeft: "-10px", width: "20px", height: "20px" }}
                  src={AudioIcon}
                />
                <p
                  style={{
                    color: "#FFFF",
                    fontSize: "12px",
                    marginLeft: "10px",
                  }}
                >
                  Audio
                </p>
              </Button>
              <Button
                data-testid="clear"
                variant="outlined"
                style={{
                  borderRadius: "0px",
                  margin: "0.1rem",
                  background: "#E6F7FF",
                  minWidth: "22%",
                  height: "60px",
                }}
                onClick={() => manipulate("delete")}
                // onClick={() =>
                //   setRemoteURI(inputRef.current.value.slice(0, -1))
                // }
              >
                <Backspace style={{ color: "#314B9F" }} />
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

Keyboard.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.any,
  remoteURI: PropTypes.string.isRequired,
  setRemoteURI: PropTypes.func.isRequired,
  session: PropTypes.any,
  inputRef: PropTypes.any,
  makeCall: PropTypes.any,
  setCallDate: PropTypes.any,
};

export default Keyboard;
